"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AppLayout_1 = __importDefault(require("@/Layouts/AppLayout"));
var react_i18next_1 = require("react-i18next");
var AccountSettingsComponent_1 = __importDefault(require("@/Components/AccountSettings/AccountSettingsComponent"));
function AccountSettings() {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    return (react_1.default.createElement(AppLayout_1.default, { title: t("Account Settings"), renderHeader: function () { return (react_1.default.createElement("h2", { className: "header" }, t("Account Settings"))); } },
        react_1.default.createElement(AccountSettingsComponent_1.default, null)));
}
exports.default = AccountSettings;
